/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import { Spin, Tabs } from 'antd';
import './index.less';
import 'whatwg-fetch';

import Markdown from 'react-markdown';
import tutorMd from './tutorial.md';
import aboutMd from './about.md';

// 页尾部分
import Footer from '../layout/Footer';
import { FooterDataSource } from '../layout/data.source.js';

export default class BrainMeta extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      active: 'cis-sQTL',
      tutorial_markdown: '',
      about_markdown: '',
    };
  }

  componentWillMount() {
    fetch(tutorMd)
      .then(res => res.text())
      .then(text => this.setState({ tutorial_markdown: text }));

    fetch(aboutMd)
      .then(res => res.text())
      .then(text => this.setState({ about_markdown: text }));
  }

  componentDidMount() {
    this.setState({ loading: true });

    const{ history, location } = this.props;
    const { search } = location;

    if(search === ''){
      history.push({
        pathname: location.pathname,
        search: 'type=cis-sQTL'
      });
    } else {
      const type = search.replace('?type=', '');
      this.setState({
        active: type || 'cis-sQTL'
      });
    }

    // 接口请求
    const iframe = this.refs.Iframe;

    if (iframe) {
      // 兼容处理
      if (iframe.attachEvent) {
        // IE
        iframe && iframe.attachEvent("onload", () => {
          this.setState({
            loading: false
          });
        });
      } else {
        // 非IE
        iframe.onload = () => {
          this.setState({
            loading: false
          });
        };
      }
    }
  };

  updateSearch(targetKey,targetValue) {
    const { location } = this.props;
    const { search } = location;
    let queryStr = search.slice(1);
    let queryArr = queryStr.split('&');
    let targetIndex = -1;

    queryArr.forEach((item,i) => {
      let key = item.split('=')[0];
      if(key === targetKey){
        targetIndex = i;
      }
    });

    //如果查找不到name，返回原始search
    if(targetIndex === -1){
      return search;
    }
    
    let targetArr = queryArr[targetIndex].split('=');
    targetArr[1] = targetValue;
    queryArr[targetIndex] = targetArr.join('=');
    return queryArr.join('&');
  }

  onChangeTab = (activeKey) => {
    const{ history, location } = this.props;

    this.setState({
      active: activeKey
    }, () => {
      history.push({
        pathname: location.pathname,
        search: this.updateSearch('type', activeKey)
      });
    });
  };

  render() {
    const { loading, active, tutorial_markdown, about_markdown } = this.state;

    const cis_sqtl = (
      <Spin id="Iframe" key="Iframe" size="large" spinning={loading} className="database-loading-style" tip="Loading...">
        <iframe 
          ref="Iframe"
          title="data"
          className="meta-iframe-style"
          src="https://yanglab.westlake.edu.cn/data/brainmeta/cis_sqtl/" 
        >
        </iframe>
      </Spin>
    );

    const trans_sqtl = (
      <Spin id="Iframe" key="Iframe" size="large" spinning={loading} className="database-loading-style" tip="Loading...">
        <iframe 
          ref="Iframe"
          title="data"
          className="meta-iframe-style"
          src="https://yanglab.westlake.edu.cn/data/brainmeta/trans_sqtl/" 
        >
        </iframe>
      </Spin>
    );

    const cis_eqtl = (
      <Spin id="Iframe" key="Iframe" size="large" spinning={loading} className="database-loading-style" tip="Loading...">
        <iframe 
          ref="Iframe"
          title="data"
          className="meta-iframe-style"
          src="https://yanglab.westlake.edu.cn/data/brainmeta/cis_eqtl/" 
        >
        </iframe>
      </Spin>
    );

    const trans_eqtl = (
      <Spin id="Iframe" key="Iframe" size="large" spinning={loading} className="database-loading-style" tip="Loading...">
        <iframe 
          ref="Iframe"
          title="data"
          className="meta-iframe-style"
          src="https://yanglab.westlake.edu.cn/data/brainmeta/trans_eqtl/" 
        >
        </iframe>
      </Spin>
    );

    // 降级方案：直接通过Iframe嵌入杨老师官网页面
    // const tutorial = (
    //   <Spin id="Iframe" key="Iframe" size="large" spinning={loading} className="database-loading-style" tip="Loading...">
    //     <iframe 
    //       ref="Iframe"
    //       title="data"
    //       className="meta-iframe-style"
    //       src="https://yanglab.westlake.edu.cn/data/brainmeta/tutorial.html" 
    //     >
    //     </iframe>
    //   </Spin>
    // );

    // const about = (
    //   <Spin id="Iframe" key="Iframe" size="large" spinning={loading} className="database-loading-style" tip="Loading...">
    //     <iframe 
    //       ref="Iframe"
    //       title="data"
    //       className="meta-iframe-style"
    //       src="https://yanglab.westlake.edu.cn/data/brainmeta/cis_sqtl/about" 
    //     >
    //     </iframe>
    //   </Spin>
    // );
    
    return (
      <div
        className="templates-wrapper"
        ref={(d) => {
          this.dom = d;
        }}
      >
        <Tabs defaultActiveKey="cis-sQTL" activeKey={active} className="meta-tab" onChange={this.onChangeTab}>
          <Tabs.TabPane tab="cis-sQTL" key="cis-sQTL">
            {cis_sqtl}
          </Tabs.TabPane>
          <Tabs.TabPane tab="trans-sQTL" key="trans-sQTL">
            {trans_sqtl}
          </Tabs.TabPane>
          <Tabs.TabPane tab="cis-eQTL" key="cis-eQTL">
            {cis_eqtl}
          </Tabs.TabPane>
          <Tabs.TabPane tab="trans-eQTL" key="trans-eQTL">
            {trans_eqtl}
          </Tabs.TabPane>
          <Tabs.TabPane tab="Tutorial" key="tutorial">
            <Markdown className="meta-iframe-style meta-markdown" escapeHtml={false}>
              {tutorial_markdown}
            </Markdown>
          </Tabs.TabPane>
          <Tabs.TabPane tab="About" key="about">
            <Markdown className="meta-iframe-style meta-markdown" escapeHtml={false}>
              {about_markdown}
            </Markdown>
          </Tabs.TabPane>
        </Tabs>
        <Footer 
          id="Footer"
          key="Footer"
          dataSource={FooterDataSource} 
        />
      </div>
    );
  }
}
